export const Options = {
    PreferredLocation: [
        { text:"Osnabrück",value:"1"},
        { text:"Melle",value:"2"},
        { text:"Papenburg",value:"3"},
        { text:"Meppen",value:"4"},
        { text:"Herford", value:"5"},
        { text:"Bad Essen",value:"6"},
    ]
}
